import React, { Component, ErrorInfo, ReactNode } from 'react';

/**
 * 全站 render 保底（porsche #14）。
 * 任何 page render / useState initializer throw（如 lifeData stale cache）都被 catch，
 * 顯 fallback UI + 重整/回首頁，避免整棵 route 卸載成空白頁。
 */
interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('[ErrorBoundary] uncaught:', error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  handleGoHome = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/home';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '60vh', display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center', padding: 24, textAlign: 'center',
        }}>
          <h2 style={{ marginBottom: 16 }}>頁面載入異常 / Page load error</h2>
          <p style={{ color: '#666', marginBottom: 24, maxWidth: 480 }}>
            系統暫時無法顯示此頁面，請重整或返回首頁。<br />
            Sorry, this page cannot be displayed. Please reload or go home.
          </p>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <pre style={{
              background: '#f5f5f5', padding: 12, borderRadius: 4,
              maxWidth: 800, overflow: 'auto', fontSize: 12, marginBottom: 16,
            }}>
              {this.state.error.message}
              {'\n\n'}
              {this.state.error.stack}
            </pre>
          )}
          <div style={{ display: 'flex', gap: 12 }}>
            <button onClick={this.handleReload} className="btn-primary">重整 / Reload</button>
            <button onClick={this.handleGoHome} className="btn-secondary">回首頁 / Home</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
